import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';

const umamiUrl = import.meta.env.VITE_UMAMI_URL;
const umamiSiteId = import.meta.env.VITE_UMAMI_SITE_ID;

if (umamiUrl && umamiSiteId) {
  const s = document.createElement('script');
  s.async = true;
  s.defer = true;
  s.src = umamiUrl;
  s.dataset['websiteId'] = umamiSiteId;
  document.head.appendChild(s);
}

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found');

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
